"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// As defined in https://github.com/mozilla/pdf.js/blob/master/src/shared/util.js#L378-L381
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var _default = PasswordResponses;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-pdf/dist/PasswordResponses.js
// module id = 817
// module chunks = 0